export default __webpack_public_path__ + "static/media/004-football.3c7dd046.svg";